module.exports = __webpack_public_path__ + "static/media/info-icon.09a12590.svg";